import { Injectable, NgZone } from '@angular/core';
import { CapAlertService } from '../../core/extension/exceptions/cap-alert.service';

@Injectable()
export class PersonstammAlertService {
  constructor(
    protected capAlertService: CapAlertService,
    protected ngZone: NgZone
  ) {}

  error(translatedMessage) {
    this.ngZone.run(() => {
      // error handlers often run outside the zone (for instance for HTTP 403 errors)
      this.capAlertService.danger(translatedMessage);
    });
  }

  info(translatedMessage) {
    this.capAlertService.info(translatedMessage);
  }
}
